module.exports = __webpack_public_path__ + "img/remove-fill.f23e6a4a.svg";